import { LISTING_FACETS } from './filtering-fragment'
import {
    LISTING,
    LISTING_DISCOUNT,
    LISTING_EDGES,
    LISTING_VARIANT,
} from './listing-fragment.js'
import {
    STOREFRONT,
    STOREFRONT_BRANDCARD,
    STOREFRONT_DISCOUNT,
    STOREFRONT_EDGES,
    STOREFRONT_EDGES_LIGHT,
} from './storefront-fragment.js'

export const FRAGMENT_LISTING = LISTING
export const FRAGMENT_LISTING_EDGES = LISTING_EDGES
export const FRAGMENT_LISTING_VARIANT = LISTING_VARIANT
export const FRAGMENT_LISTING_DISCOUNT = LISTING_DISCOUNT

export const FRAGMENT_STOREFRONT = STOREFRONT
export const FRAGMENT_STOREFRONT_BRANDCARD = STOREFRONT_BRANDCARD
export const FRAGMENT_STOREFRONT_EDGES = STOREFRONT_EDGES
export const FRAGMENT_STOREFRONT_EDGES_LIGHT = STOREFRONT_EDGES_LIGHT
export const FRAGMENT_STOREFRONT_DISCOUNT = STOREFRONT_DISCOUNT

export const FRAGMENT_LISTING_FACETS = LISTING_FACETS
